var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-1 pt-12 ma-0"},[_c('CashbookTemplateGrid',{on:{"EditItem":_vm.onEditItem,"ViewItem":_vm.onViewItem,"DeleteItem":_vm.onDeleteItem,"AddItem":_vm.onAddItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }